import angular from 'angular';
import fileHeader from './fileHeader';

export default angular
  .module('components.fileHeader', [])
  .component('fileHeader', fileHeader).name;
